import React from "react";
import { Button } from "../Buttons";

/**
 * AddBtn - Button for adding a new row to a table
 * 
 * @param {Object} props
 * @param {function} props.onClick - Click handler
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {Object} props.style - Additional styles to apply
 * @param {string} props.title - Tooltip text
 * 
 * @example
 * <AddBtn onClick={handleAddRow} disabled={false} title="Add new row" />
 */
const AddBtn = ({ onClick, disabled = false, style = {}, title }) => {
  return (
    <Button 
      onClick={onClick} 
      variant="gray"
      size="md"
      style={{ width: "100px", ...style }}
      disabled={disabled}
      title={title}
    >
      + Add Row
    </Button>
  );
};

export default AddBtn;


